import { useUser } from 'context/User'
import Text from 'openspace/components/Text'
import { PropsWithChildren, useMemo } from 'react'
import Button from '@onepercentio/one-ui/components/Button'
import { t } from 'translate/i18n'
import { useHistory } from 'react-router-dom'
import ROUTES, { TO_SIGNIN } from 'core/modules/router'
import { FigmaTypo } from 'containers/OneUIProvider/OneUIProvider.data'

export default function RestrictToCVM({
  children,
  goToCVMFlow,
}: PropsWithChildren<{ goToCVMFlow: () => void }>) {
  const h = useHistory()
  const { profile } = useUser()
  const cvmStatus = useMemo(() => {
    if (!profile) return 'signin'
    return profile.cvm88Status
  }, [profile])
  switch (cvmStatus) {
    case 'signin':
      return (
        <>
          <Text code='offerDetails.forum.error.signin' type={FigmaTypo.P16} />
          <Button onClick={() => h.push(TO_SIGNIN())} variant='filled'>
            {t('topbar.auth.login')}
          </Button>
        </>
      )
    case undefined:
      return (
        <>
          <Text
            code='offerDetails.forum.error.cvm.required'
            type={FigmaTypo.P16}
          />
          <Button onClick={() => goToCVMFlow()} variant='filled'>
            {t('offerDetails.forum.error.cvm.actions.goToCVM')}
          </Button>
        </>
      )
    case 'pending':
      return (
        <>
          <Text
            code='offerDetails.forum.error.cvm.pending'
            type={FigmaTypo.P16}
          />
        </>
      )
    case 'rejected':
      return (
        <>
          <Text
            code='offerDetails.forum.error.cvm.rejected'
            type={FigmaTypo.P16}
            color='error'
          />
        </>
      )
    case 'approved':
      return children
  }
}
